import { render, staticRenderFns } from "./StaffOnboardCustomerView.vue?vue&type=template&id=0ffa3fd4&scoped=true"
import script from "./StaffOnboardCustomerView.vue?vue&type=script&lang=js"
export * from "./StaffOnboardCustomerView.vue?vue&type=script&lang=js"
import style0 from "./StaffOnboardCustomerView.vue?vue&type=style&index=0&id=0ffa3fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa3fd4",
  null
  
)

export default component.exports